import { MONTHS } from '@/constants';

export const transformMonthToNumber = month => MONTHS.indexOf(month) + 1;

export const transformMonthToString = num => MONTHS[num - 1];
